import { render } from "./testSubTaskEdit.vue?vue&type=template&id=68b89118&scoped=true&ts=true"
import script from "./testSubTaskEdit.vue?vue&type=script&lang=ts"
export * from "./testSubTaskEdit.vue?vue&type=script&lang=ts"

import "./testSubTaskEdit.vue?vue&type=style&index=0&id=68b89118&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-68b89118"]])

export default __exports__